import { Routes, Route, Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import RouteTheme from "theme/RouteTheme";

// Public Pages
import Home from "pages/public/Home";
import TargetUsers from "pages/public/TargetUsers";
import Features from "pages/public/Features";
import Solutions from "pages/public/Solutions";
import Pricing from "pages/public/Pricing";

// External Pages
import EventRegistration from "pages/public/EventRegistration";
import EventLogging from "pages/public/EventLogging";
import ConversationLogging from "pages/public/ConversationLogging";

//Documentation Pages
import GDPRStatement from "pages/public/GDPRStatement";

// Auth Pages
import Login from "pages/public/Login";
import Register from "pages/public/Register";
import RegisterPaymentSuccess from "pages/public/RegisterPaymentSuccess";
import RegisterPaymentCancelled from "pages/public/RegisterPaymentCancelled";
import RegisterCollaborator from "pages/public/RegisterCollaborator";
import Logout from "pages/public/Logout";

// Layout
import Navbar_Public from "components/PageLayouts/PageFrames/navbar_public";
import Footer_Public from "components/PageLayouts/PageFrames/footer_public";
import Navbar_External from "components/PageLayouts/PageFrames/navbar_external";
import Footer_External from "components/PageLayouts/PageFrames/footer_external";


const PublicLayout = () => (
  <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <Navbar_Public />
    <Box component="main" sx={{ flex: 1 }}>
      <Outlet />
    </Box>
    <Footer_Public />
  </Box>
);

const ExternalLayout = () => (
  <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <Navbar_External />
    <Box component="main" sx={{ flex: 1 }}>
      <Outlet />
    </Box>
    <Footer_External />
  </Box>
);

// NEW: a themed wrapper layout for external pages
const ExternalLayoutThemed = () => (
  <RouteTheme mode="light">
    <ExternalLayout />
  </RouteTheme>
);

export default function PublicModule() {
  return (
    <Routes>
      {/* ---------------- PUBLIC LAYOUT (default = dark from app root) ---------------- */}
      <Route element={<PublicLayout />}>
        {/* Marketing Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/features/" element={<Features />} />
        <Route path="/solutions/" element={<Solutions />} />
        <Route path="/for/" element={<TargetUsers />} />
        <Route path="/pricing/" element={<Pricing />} />

        {/* Documentation Pages */}
        <Route path="/GDPR/" element={<GDPRStatement />} />

        {/* Auth Pages */}
        <Route path="/login/" element={<Login />} />
        <Route path="/register/" element={<Register />} />
        <Route path="/register/payment-success/" element={<RegisterPaymentSuccess />} />
        <Route path="/register/payment-cancelled/" element={<RegisterPaymentCancelled />} />
        <Route path="/register/collaborator/:publicToken/" element={<RegisterCollaborator />} />
        <Route path="/logout/" element={<Logout />} />
      </Route>

      {/* ---------------- EXTERNAL LAYOUT (force light) ---------------- */}
      <Route element={<ExternalLayoutThemed />}>
        <Route path="/event/registration/:token/" element={<EventRegistration />} />
        <Route path="/event/attendance/:token/" element={<EventLogging />} />
        <Route path="/conversations/:token/" element={<ConversationLogging />} />
      </Route>
    </Routes>
  );
}
